/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import {
  useMediaQuery,
  Grid,
} from '@material-ui/core';
import ErrorIcon from '@assets/images/ban_and_lock/error-icon.png';
import { useTheme } from '@material-ui/core/styles';
import './OtpForm.css';

function OtpForm({
  changeSubmitColor,
  showErrorMessage,
  otpCode,
  errorMessage,
  loginViaSSO,
  sendOTP,
  timer,
  disableResend,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const otpFieldRef = useRef();
  // filter the values to be number only using regex
  const numberOnly = (input) => {
    otpFieldRef.current.value = input.target.value.replace(/\D/gi, '');
  };
  return (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
      id='otp-container-id'
    >
      <div>
        <input
          ref={otpFieldRef}
          placeholder='Enter code'
          inputMode='numeric'
          autoComplete='one-time-code'
          onInput={(input) => numberOnly(input)}
          value={otpCode}
          onChange={(e) => changeSubmitColor(e)}
          className='otp-field-form-style'
          id='otp-form-id'
          maxLength={6}
        />
        {showErrorMessage && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              minWidth: 300,
              marginLeft: 5,
              marginTop: 10,
              maxWidth: 300,
            }}
          >
            <img src={ErrorIcon} alt='error-icon' width={15} height={15} />
            <p
              style={{
                fontFamily: 'CircularXX-Book',
                textAlign: 'left',
                fontSize: 12,
                color: '#E32B2B',
                marginLeft: 10,
              }}
            >
              {errorMessage}
            </p>
          </div>
        )}
        <button type='button' onClick={loginViaSSO} id='submit-btn' className='submit-btn-style'>Submit</button>
        <div
          style={{
            marginTop: 10,
            marginBottom: isMobile ? 99 : 149,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p style={{ fontFamily: 'CircularXX-Book', fontSize: 12 }}>
            Did not receive a code?
            {disableResend ? (
              <span style={{ marginLeft: 3 }}>
                Request a new code in
                {' '}
                {timer}
              </span>
            )
              : <span style={{ textDecoration: 'underline', marginLeft: 3, cursor: 'pointer' }} onClick={sendOTP}>Resend Code</span>}
          </p>
        </div>
      </div>
    </Grid>
  );
}

export default OtpForm;
